import styles from "./FillInField.module.css"
import React from 'react';
/**
* Props for the FillInField component.
*/ 
interface FillInFieldProps {
    onChange?: (value: string| number) => void, // Change event handler
    value?: string | number, // Current value
    className? :string, // Optional additional class
    label?:string, // Label
    placeholder?: string, // Placeholder
    type?: string, // Input type
    disabled?:boolean // Whether the input is disabled
}
/**
* An input field component supporting various types and customization.
*
* @param props FillInField props
* @param {(value: string|number) => void} props.onChange - Change event handler
* @param {string|number} props.value - Current value
* @param {string} props.className - Optional additional class
* @param {string} props.label - Label
* @param {string} props.placeholder - Placeholder
* @param {string} props.type - Input type
* @param {boolean} props.disabled - Whether the input is disabled
* @returns TSX.Element
*/
const FillInField: React.FC<FillInFieldProps> = ({ type ="text" , onChange, value, className, label, placeholder, disabled = false}) => {
    
    return(
        <>
        <div className={`${styles.InfoInputGroup}`}>
            {label && <p>{label}</p>}
            <div className={`${styles.PrimaryInputBlock} ${className ?? ''} ${disabled ? styles.DisabledInput : ''}`}>
                <div className={styles.PrimaryInputCenter}>
                    <input 
                    type={type} 
                    className={`${styles.PrimaryInputField} ${value ? styles.InputFilled: ''}`}
                    onChange={(e)=>onChange && onChange(e.target.value)}
                    value={value}
                    placeholder={placeholder ? placeholder : ""}
                    disabled={disabled}
                    />
                </div>
            </div>
        </div>
        </>
    )
};

export default FillInField;